<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Política de Senhas" />
    <menuLateral />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
      </section>

      <!-- Main content -->
      <section class="content">
        <div v-show="carregandoDados.status" class="d-flex align-items-center mb-3">
          <b-spinner  :style="{ visibility: carregandoDados.status ? 'visible' : 'hidden' }" class="mr-2" variant="danger"></b-spinner>
          <span class="avisoDanger">{{carregandoDados.mensagem}}</span>
        </div>
        <div class="container-fluid">
          <div class="card">
            <div class="card-body" v-if="flagsLocais">
              <div
                v-for="flag in configuracoesFlags"
                :key="flag.chave"
                class="d-flex align-items-start justify-content-between py-3 border-bottom"
              >
                <div class="mr-4">
                  <p class="mb-0 font-weight-bold">{{ flag.titulo }}</p>
                  <small class="text-muted">{{ flag.descricao }}</small>
                  <div v-if="dadosRetorno.listaDeErros[flag.chave]" class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros[flag.chave]}}</div>
                </div>
                <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success flex-shrink-0">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="'flag-' + flag.chave"
                    :disabled="manipulandoDados.status||carregandoDados.status"
                    v-model="flagsLocais[flag.chave]"
                  />
                  <label class="custom-control-label" :for="'flag-' + flag.chave"></label>

                </div>
              </div>
              <div v-show="manipulandoDados.status" class="d-flex align-items-center mt-3">
                <b-spinner  :style="{ visibility: manipulandoDados.status ? 'visible' : 'hidden' }" class="mr-2" variant="danger"></b-spinner>
                <span class="avisoDanger">{{manipulandoDados.mensagem}}</span>
              </div>
            </div>
            <div class="card-footer">
              <div class="text-right">
                 <button
                  class="btn botoes btn-outline-success btn-sm mt-2"
                  :disabled="manipulandoDados.status||carregandoDados.status"
                  @click="salvar"
                >
                Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import PoliticaSeguranca from './js/politica-seguranca'
export default PoliticaSeguranca
</script>
